const extractFirstResult = (prop) => {
  if (prop && prop.results && prop.results.length > 0) {
    return prop.results[0].item;
  }
};

const extractResults = (prop) => {
  if (prop && prop.results && prop.results.length > 0) {
    return prop.results.map((hit) => hit.item);
  }
  return [];
};

const SET_SUBJECT_DASHBOARD = (state, payload) => {
  state.selectedSubject = {
    id: payload.subject.id,
    name: payload.subject.name,
    description: payload.subject.description,

    mostReadItem: extractFirstResult(payload.mostRead),
    mostSharedItem: extractFirstResult(payload.mostShared),
    mostCitedItem: extractFirstResult(payload.mostCited),

    latestItems: extractResults(payload.latestItems),
  };

  state.user = payload.user;
  state.usageEventsDisabled = payload.usageEventsDisabled;
};

export default SET_SUBJECT_DASHBOARD;
